import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '../../main/components/SvgIcon';

// Icon names reused from the BMC canvas left-hand menu
const STEP_ICON_NAMES = ['ideation', 'canvas', 'testing', 'portfolio'];

const SignUpInfo = ({ locales: { onboarding: pageLocales } }) => {
  return (
    <div className="rounded-2xl bg-[#007AFF] text-white px-24 py-12 h-full flex items-center">
      <div className="space-y-4">
        <h2 className="text-3xl font-semibold leading-tight">
          {pageLocales.infoTitle}
        </h2>
        <ul className="space-y-3 text-base">
          {pageLocales.infoTabTitles.map((title, index) => (
            <li key={index} className="flex items-center gap-3">
              {STEP_ICON_NAMES[index] && (
                <span
                  className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/60 bg-[#007AFF]"
                  aria-hidden="true"
                >
                  <SvgIcon name={STEP_ICON_NAMES[index]} />
                </span>
              )}
              <span>{title}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

SignUpInfo.propTypes = {
  locales: PropTypes.object.isRequired,
};

export default SignUpInfo;
